import React from 'react';

const ConfirmationPopup = ({ show, onConfirm, onCancel, title, message, deleting = false }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-2xl shadow-lg w-96 p-6">
        <h2 className="text-lg font-bold mb-2">{title || "Are you sure?"}</h2>
        <p className="text-gray-600 mb-4">{message || "Do you really want to delete this item?"}</p>
        <div className="flex justify-end space-x-3">
          <button
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
            onClick={onCancel}
            disabled={deleting}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            disabled={deleting}
            onClick={onConfirm}
          >
            {deleting ? "Deleting..." : "Yes, Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPopup;
